import { render, staticRenderFns } from "./InmaculadaBenito.vue?vue&type=template&id=6988f94c&scoped=true"
import script from "./InmaculadaBenito.vue?vue&type=script&lang=js"
export * from "./InmaculadaBenito.vue?vue&type=script&lang=js"
import style0 from "./InmaculadaBenito.vue?vue&type=style&index=0&id=6988f94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6988f94c",
  null
  
)

export default component.exports